import {
  AwsPartitionElement,
  awsAccountIdValidator,
  idcIdentityElement,
  idcMetadataElements,
} from "@p0security/integrations-aws-shared/components";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const AwsMidcComponents = InstallSpec({
  identity: ItemComponent({
    label: "Identity Center account",
    description:
      "Allows P0 to grant and revoke AWS access via Identity Center permission sets and resource policies.",
    type: "string",
    maturity: "ga",
    schema: {
      idcRegion: Element({
        type: "string",
        label: "AWS region where Identity Center is installed",
        description: "e.g. us-east-1",
        step: "new",
      }),
      awsPartition: AwsPartitionElement,
      ...idcMetadataElements,
      identity: idcIdentityElement,
      serviceAccountEmail: Element({
        type: "hidden",
        label: "P0 service account email",
      }),
      serviceAccountId: Element({
        type: "hidden",
        label: "P0 service account ID",
      }),
    },
    validator: awsAccountIdValidator,
  }),
});
